import { useEffect, useState } from 'react';
import apiClient from '../../../services/api/client';

interface ModuleStatsState<T> {
  data: T | null;
  loading: boolean;
  error: boolean;
}

/**
 * Fetch a module's statistics endpoint for a dashboard section.
 * 403/errors resolve to `error: true` so sections can hide themselves
 * instead of breaking the page (permission-graceful by design).
 */
export function useModuleStats<T = any>(url: string, enabled: boolean = true): ModuleStatsState<T> {
  const [state, setState] = useState<ModuleStatsState<T>>({
    data: null,
    loading: enabled,
    error: false,
  });

  useEffect(() => {
    if (!enabled) {
      setState({ data: null, loading: false, error: false });
      return;
    }
    let cancelled = false;
    setState({ data: null, loading: true, error: false });
    apiClient
      .get(url)
      .then((res) => {
        if (cancelled) return;
        const payload = res.data?.data ?? res.data;
        setState({ data: payload, loading: false, error: false });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ data: null, loading: false, error: true });
      });
    return () => { cancelled = true; };
  }, [url, enabled]);

  return state;
}

export default useModuleStats;
